import React, { FC } from 'react';

export const NotificationLoader: FC = () => (
	<div className="flex flex-col justify-between bg-white">
		{Array.from(new Array(3)).map((ele, i) => (
			<div role="status" className="max-w-sm animate-pulse flex-col rounded p-4 " key={i}>
				<div className="flex items-center justify-center gap-2 space-x-3">
					<div className="h-16 w-16 rounded-2xl bg-gray-200"></div>
					<div className="flex flex-col items-start justify-center">
						<div className="mb-2 h-5 w-16 rounded-full bg-gray-200 dark:bg-gray-700"></div>
						<div className=" h-7 w-60 rounded-full bg-gray-200 dark:bg-gray-700"></div>
					</div>
				</div>
			</div>
		))}
	</div>
);
